/**
 * The set-password page at an identity home's login hostname,
 * `<base host>/<label>/set-password` (TECH-3456). Not nested under the sign-in
 * page at `/$label` (the trailing `_`), because it is a page of its own rather
 * than a part of that one; it sends the user there once the password is set.
 *
 * The label is never read here, as on the sign-in page: the server reads it from
 * the address, and the link's own identity home must match.
 */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SetPasswordPage } from "@/components/auth/set-password-page";
import { validateRedirectSearch } from "@/components/auth/sign-in-page";

export const Route = createFileRoute("/$label_/set-password")({
	// The client a welcome email was for rides here as `?redirect=`, and is
	// handed on to the sign-in page, which lands the user in it.
	validateSearch: validateRedirectSearch,
	component: SetPasswordRoute,
});

function SetPasswordRoute() {
	const { label } = Route.useParams();
	const { redirect } = Route.useSearch();
	const navigate = useNavigate();
	return (
		<SetPasswordPage
			onPasswordSet={() =>
				navigate({
					to: "/$label",
					params: { label },
					search: redirect ? { redirect } : {},
				})
			}
		/>
	);
}
